import { defineComponent as _defineComponent } from 'vue'
import { type FavoritesToken, useFavoritesStore } from "@/pinia";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FavoritesStar',
  props: {
    token: null
  },
  setup(__props: any) {

const props = __props as {
	token: FavoritesToken;
};



const favoritesStore = useFavoritesStore();
const isFavorite = computed(() =>
	favoritesStore.isFavorite(props.token?.address ?? "")
);

const handleClick = (e: MouseEvent) => {
	e.preventDefault();
	e.stopPropagation();
	favoritesStore.toggleFavorite(props.token);
};

return { __sfc: true,props, favoritesStore, isFavorite, handleClick }
}

})